import React, { Component } from 'react'

export default class EmprendimientoDetail extends Component {

  componentWillMount() {
    //TODO - ESTO SE VA
  }

  render () {

    return (
    	<div className="container-fluid">
    		<p>construyendo el emprendimiento detail..</p>
    	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/PageEntrepreneurship/components/Detail/index.js